import { Box, Dialog, Typography } from "@mui/material";

const WelcomeModal = () => {
  const keepOpen = () => {};

  return (
    <Dialog
      open
      onClose={keepOpen}
      disableEscapeKeyDown
      aria-labelledby="welcome-modal-title"
      aria-describedby="welcome-modal-description"
      maxWidth={false}
      sx={styles.dialog}
      PaperProps={{ sx: styles.paper }}
    >
      <Box sx={styles.container}>
        <Box
          component="img"
          src="https://centromedicomedam.com/IMG/centromedicoMEDAM/Img_medam_Family.png"
          alt="Familia reunida en un momento de cuidado y bienestar"
          sx={styles.familyImage}
        />
        <Box sx={styles.content}>
          <Box
            component="img"
            src="https://centromedicomedam.com/IMG/Logos/Logo_Negro_del_centro-medico_MEDAM.png"
            alt="Centro Médico Medam"
            sx={styles.logo}
          />
          <Typography id="welcome-modal-description" sx={styles.title}>
            El futuro del cuidado
            <br />
            de tu salud
          </Typography>
        </Box>
      </Box>
    </Dialog>
  );
};

export default WelcomeModal;

const styles = {
  dialog: {
    "& .MuiBackdrop-root": {
      backgroundColor: "rgba(13, 27, 52, 0.62)",
      backdropFilter: "blur(2px)",
    },
  },
  paper: {
    width: { xs: "calc(100vw - 16px)", sm: 635 },
    height: { xs: "auto", sm: 470 },
    maxWidth: "none",
    maxHeight: "calc(100vh - 16px)",
    margin: 1,
    overflow: "hidden",
    borderRadius: "22px",
    backgroundColor: "#f6f7f8",
    boxShadow: "none",
  },
  container: {
    position: "relative",
    width: "100%",
    height: "100%",
    overflow: "hidden",
    backgroundColor: "#f6f7f8",
  },
  familyImage: {
    position: "absolute",
    width: { xs: 330, sm: 350 },
    height: "auto",
    bottom: 0,
    maxWidth: "none",
    display: "block",
    userSelect: "none",
    pointerEvents: "none",
  },
  content: {
    position: "absolute",
    left: { xs: "45%", sm: 295 },
    right: { xs: 15, sm: 25 },
    top: { xs: 35, sm: 48 },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  logo: {
    width: { xs: 190, sm: 280 },
    height: "auto",
    display: "block",
  },
  title: {
    marginTop: 10,
    color: "#30343a",
    fontFamily: "Plus Jakarta Sans, sans-serif",
    fontSize: {
      xs: 22,
      sm: 29,
    },
    fontWeight: 400,
    lineHeight: 1.25,
    textAlign: "center",
  },
};
